import React, { useState } from "react";
import { TextField, Box, Chip, Typography } from "@mui/material";

const EmailsInput = ({ emails, setEmails, disabled }) => {
    const [inputValue, setInputValue] = useState("");
    const isValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const addEmail = (value) => {
        const email = value.trim();
        if (email && isValidEmail(email) && !emails.includes(email.toLowerCase())) {
        setEmails([...emails, email.toLowerCase()]);
        }
    };

    const handleDelete = (emailToDelete) => {
        setEmails(emails.filter((email) => email !== emailToDelete));
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === ",") {
            event.preventDefault();
            addEmail(inputValue);
            setInputValue("");
        }
    };

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 280, maxWidth: 400 }}>
            <TextField
                variant="standard"
                value={inputValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="Type email and press Enter or comma"
                disabled={disabled}
                sx={{ flexGrow: 1, minWidth: 150 }}
                inputProps={{ spellCheck: "false", autoComplete: "off" }}
            />
            <Box
                sx={{
                    display: "flex",
                    overflowX: "auto",
                    py: 1,
                    gap: 0.5,
                    maxWidth: 200,
                    ml: 1,
                    whiteSpace: "nowrap",
                }}
            >
                {emails.map((email) => (
                    <Chip
                        key={email}
                        label={email}
                        onDelete={disabled ? undefined : () => handleDelete(email)}
                        color={isValidEmail(email) ? "primary" : "error"}
                        variant="outlined"
                        sx={{ flexShrink: 0 }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default EmailsInput;